
var content = require("!!../../../../../../node_modules/.pnpm/mini-css-extract-plugin@2.10.2_webpack@5.104.1/node_modules/mini-css-extract-plugin/dist/loader.js!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../../../../node_modules/.pnpm/sass-loader@16.0.2_sass@1.106.1_webpack@5.104.1/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].use[3]!./AdvisorPanel_NextSteps.scss");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../../../../node_modules/.pnpm/style-loader@0.23.1/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../../../../node_modules/.pnpm/mini-css-extract-plugin@2.10.2_webpack@5.104.1/node_modules/mini-css-extract-plugin/dist/loader.js!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../../../../node_modules/.pnpm/sass-loader@16.0.2_sass@1.106.1_webpack@5.104.1/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].use[3]!./AdvisorPanel_NextSteps.scss", function() {
		var newContent = require("!!../../../../../../node_modules/.pnpm/mini-css-extract-plugin@2.10.2_webpack@5.104.1/node_modules/mini-css-extract-plugin/dist/loader.js!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.104.1/node_modules/css-loader/dist/cjs.js!../../../../../../node_modules/.pnpm/sass-loader@16.0.2_sass@1.106.1_webpack@5.104.1/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].use[3]!./AdvisorPanel_NextSteps.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}